import { React, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import QuinekLogo from '../Images/logo_1024_w.png';
import Terms from './Terms';

const LoginView = (props) => {

    const auth = props.auth;
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const login = (e) => {
        e.preventDefault();
        signInWithEmailAndPassword(auth, username, password)
        .then((_) => {
                console.log("Valid credentials.");
            })
        .catch((error) => {
            console.log('Error: ',error);
            alert(error);
        });
    }    

    return (
        <>
        <Routes>
            <Route path="/" element={
                <div className='p-5'>
                    <div id="LoginBox">
                        <div className=''>
                            <img className='QuinekLogo' src={QuinekLogo} alt='Login'/>
                        </div>
                        <div>
                            <p className='Title Centered'>Iniciar Sesion</p>
                        </div>
                        <div>
                            <form action='#'>
                                <label className='tx-white'>Nombre de usuario</label>
                                <input onChange={(e) => setUsername(e.target.value)} id='login_username' className='TextInput p-1' type="text"></input>
        
                                <br/><br/>
        
                                <label className='tx-white'>Contraseña</label>
                                <input onChange={(e) => setPassword(e.target.value)} id='login_password' className='TextInput p-1' type="password"></input>
        
                                <button onClick={(e) => login(e)} className='mt-3 mx-auto btn btn-accept'>Iniciar Sesion</button>
                            </form>
                        </div>
                    </div>
                </div>
            } />
            <Route path="/Terms_Conditions/:locale" element={ <Terms /> } />
        </Routes>
        </>
    );
}

export default LoginView;